
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gramas",
      function () {
        return require("private-next-pages/gramas/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gramas"])
      });
    }
  